// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  // Local Server
  // apiBase: 'http://localhost:8080/solar',
  // baseUrl: 'http://localhost:8080/solar',

  // Production Server
  apiBase: 'https://injectrenewables.com/inject-solar-angular/inject_solar_server',
  baseUrl: 'https://injectrenewables.com/inject-solar-angular/inject_solar_server',

    // apiBase: 'http://3.6.0.2/inject-solar-angular-new/inject_solar_server',
    // baseUrl: 'http://3.6.0.2/inject-solar-angular-new/inject_solar_server',

  // Staging Server
//  apiBase: 'http://3.6.240.94/inject-solar-angular/inject_solar_server',
//  baseUrl: 'http://3.6.240.94/inject-solar-angular/inject_solar_server',

  env: 'prod'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */

// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
